import { useTableCellContext } from './context';
import TableCellText from './TableCellText';
import TableCellBar from './TableCellBar';
import TableCellProgressBar from './TableCellProgressBar';
import TableCellBenchmark from './TableCellBenchmark';
import TableCellMultipleValues from './TableCellMultipleValues';
import TableCellCustomChildren from './TableCellCustomChildren';
import TableCellStarChildren from './TableCellStarChildren';
import TableCellScore from './TableCellScore';
import TableCellBadge from './TableCellBadge';
import { Td, useTheme } from '@chakra-ui/react';

const CELLS = {
  text: <TableCellText />,
  bar: <TableCellBar />,
  progress: <TableCellProgressBar />,
  benchmark: <TableCellBenchmark />,
  multipleValues: <TableCellMultipleValues />,
  score: <TableCellScore />,
  badge: <TableCellBadge />,
  customChildren: <TableCellCustomChildren />,
  star: <TableCellStarChildren />
};

const TableCellWrapper = () => {
  const theme = useTheme();

  const {
    width,
    maxWidth,
    padding,
    height,
    minHeight,
    backgroundColor,
    borderRadius,
    border,
    borderWidth,
    blur,
    colSpan,
    rowSpan,
    dataTestTDId,
    cellType
  } = useTableCellContext();

  return (
    <Td
      width={width || 'fit-content'}
      maxWidth={maxWidth || 'fit-content'}
      height={height || 'initial'}
      minHeight={minHeight || 'initial'}
      backgroundColor={backgroundColor || theme.colors.white}
      borderRadius={borderRadius || 0}
      border={border || 'none'}
      borderWidth={borderWidth || 0}
      padding={padding || 0}
      px='6px'
      css={
        blur
          ? {
              WebkitFilter: `blur(${blur})`,
              MozFilter: `blur(${blur})`,
              OFilter: `blur(${blur})`,
              msFilter: `blur(${blur})`,
              filter: `blur(${blur})`
            }
          : {}
      }
      blur={blur}
      colSpan={colSpan}
      rowSpan={rowSpan}
      data-testid={dataTestTDId || 'cj-tablecell-container-id'}
    >
      {CELLS[cellType || 'text']}
    </Td>
  );
};

export default TableCellWrapper;
